<template>
  <div class="delayedTrucks">
    <h3 v-if="title" class="topTitle">Atrasos en ETA
      <b class="green">{{sectionName}}</b></h3>
    <div class="delayedTrucksTable roundedBorder">
      <el-table :data="delayedTrucksData" height="100%">
        <el-table-column
          prop="truck"
          fixed="left"
          min-width="110"
          label="Patente"
          align="center">
        </el-table-column>
        <el-table-column
          label="Tiempo atraso"
          min-width="110"
          align="left">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">
              {{ scope.row.delay | moment}} hrs
            </span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="Detalle"
          width="75px">
          <template slot-scope="scope">
            <el-button
              v-if="byEnterprise"
              type="text"
              @click="selectRoute(scope.row.truck)">Ver más</el-button>
            <el-link
              v-else
              type="falabella"
              :underline="false"
              :href="scope.row.detail">Ver más</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import BaseTravelTime from './BaseTravelTime.vue';

export default {
  props: {
    title: {
      type: Boolean,
      default: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    byEnterprise: {
      type: Boolean,
      default: false,
    },
    delayedTrucksTotalData: {
      type: Array,
      required: true,
    },
  },
  component: {
    BaseTravelTime,
  },
  data() {
    return {
      delayedTrucksData: [],
    };
  },
  methods: {
    selectRoute(patent) {
      this.$emit('clickPatent', patent);
    },
    setData() {
      const lista = [];
      if (this.delayedTrucksTotalData.length > 0) {
        if (this.delayedTrucksTotalData[0].delayed_routes != null) {
          this.delayedTrucksTotalData[0].delayed_routes.forEach((element) => {
            const aux = {
              truck: element.Route.vehicle.patent,
              delay: element.Delay,
              detail: `${window.location.origin}/app/tracing?v=${element.Route.vehicle.patent.toUpperCase()}`,
            };
            lista.push(aux);
          });
          this.delayedTrucksData = lista;
        }
      }
    },
  },
  filters: {
    moment(time) {
      let hours = '0';
      let minutes = '0';
      let seconds = '0;';
      if (time.includes('h')) {
        // eslint-disable-next-line prefer-destructuring
        hours = time.split('h')[0];
        if (time.includes('m')) {
          // eslint-disable-next-line prefer-destructuring
          minutes = time.split('m')[0].split('h')[1];
          if (time.includes('s')) {
            // eslint-disable-next-line prefer-destructuring
            seconds = time.split('s')[0].split('m')[1];
          }
        }
      } else if (time.includes('m')) {
        // eslint-disable-next-line prefer-destructuring
        minutes = time.split('m')[0];
        if (time.includes('s')) {
          // eslint-disable-next-line prefer-destructuring
          seconds = time.split('s')[0].split('m')[1];
        }
      }
      // eslint-disable-next-line radix
      const total = parseInt(seconds) + parseInt(minutes * 60) + parseInt(hours * 3600);
      const duration = moment.duration(total, 'seconds');
      if (hours !== '0') {
        return duration.format('hh:mm');
      }
      return duration.format('00:mm');
    },
  },
  beforeMount() {
    momentDurationFormatSetup(moment);
    this.setData();
  },
  watch: {
    delayedTrucksTotalData() {
      momentDurationFormatSetup(moment);
      this.setData();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/var";

  .topTitle {
    text-transform: uppercase;
    font-size: 16px;
    text-align: left;
    margin: 0 0 5px;
  }

  .green {
    color: $fb-green;
  }

  a.el-link.el-link--falabella {
    color: #a5a5a5;
    font-weight: bold;
    :hover {
      color: $fb-green;
    };
  }

  .el-button.el-button--text {
    color: #a5a5a5;
    font-weight: bold;
    :hover {
      color: $fb-green;
    };
  }

  .el-icon-time {
    color: #F55E64;
  }

  .roundedBorder {
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 3px;
    background: white;
    height: 275px;
  }
  @media only screen and (max-width: 1200px) {
    .roundedBorder {
      height: 415px;
      max-height: 415px;
    }
  }
  @media only screen and (max-width: 991px) {
    .roundedBorder {
      max-height: 300px;
    }
  }
  @media only screen and (max-width: 425px) {
    .topTitle {
      font-size: 12px;
    }
  }

</style>
